
import { createRefetchContainer, graphql } from 'react-relay';
import UserPlaylist from './UserPlaylist';

export default createRefetchContainer(UserPlaylist, {
  node: graphql`
    fragment UserPlaylistContainer_node on Playlist
      @argumentDefinitions(
        query: { type: "String!", defaultValue: "" }
      ) {
      id
      can_edit
      title
      description
      thumbnail(width: 240, height: 240) {
        url
        width
        height
      }
      playlist_songs(first: 99999)
        @connection(key: "UserPlaylistContainer_playlist_songs") {
        edges {
          node {
            id
            position
            song {
              __typename
              id
              isrc
              name
              album
              artist
              song_images {
                edges {
                  node {
                    id
                    url
                    width
                    height
                  }
                }
              }
            }
          }
        }
      }
      song_search(first: 10, query: $query) {
        edges {
          node {
            id
            name
            album
            artist
            isrc
            duration_ms
            song_images {
              edges {
                node {
                  id
                  url
                  width
                  height
                }
              }
            }
            ... on SpotifySong {
              external_id
              external_source
              external_data
            }
          }
        }
      }
    }
  `
},
graphql`
  query UserPlaylistContainer_RefetchQuery($query: String!, $id: ID!) {
    node(id: $id) {
      ...UserPlaylistContainer_node @arguments(query: $query)
    }
  }
`);



// WEBPACK FOOTER //
// ./webpack/components/App/UserPlaylistContainer.js